// @flow
import { Close as CloseIcon, Search as SearchIcon } from '@material-ui/icons';
import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from '@material-ui/core';
import * as React from 'react';
import debounce from 'debounce';

type Props = {
  defaultTerm: string,
  setFilters: any,
};

function SearchBar({ defaultTerm, setFilters }: Props) {
  const [term, setTerm] = React.useState(defaultTerm);
  const debouncedSetFilters = React.useCallback(
    debounce((value) => {
      setFilters((filters) => ({ ...filters, term: value }));
    }, 100),
    [setFilters],
  );

  return (
    <form onSubmit={(e) => e.preventDefault()}>
      <FormControl variant="filled" fullWidth>
        <InputLabel htmlFor="search-input">Búsqueda...</InputLabel>
        <OutlinedInput
          id="search-input"
          type="text"
          value={term}
          onChange={(e) => {
            setTerm(e.target.value);
            debouncedSetFilters(e.target.value);
          }}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="search button"
                onClick={() => {
                  setTerm('');
                  setFilters((filters) => ({ ...filters, term: '' }));
                }}
                edge="end"
              >
                {term ? <CloseIcon /> : <SearchIcon />}
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
    </form>
  );
}

export default SearchBar;
